import React, { useEffect, useState } from "react";
import "./Credentials.scss";
import Breadcrumb from "../../components/Breadcrum";

export default function Credentials() {
  const [activeCert, setActiveCert] = useState(null);

  const certificatesData = [
    { imgSrc: "/assets/img/certificates/Membership-Certificate.jpg", text: "FKCCI Membership" },
    { imgSrc: "/assets/img/certificates/spices-board-certificate1.jpeg", text: "Spices Board Certificate" },
    { imgSrc: "/assets/img/certificates/plastic-export.jpeg", text: "Plastics Export Promotion Council" },
    { imgSrc: "/assets/img/certificates/Environmental-Management-Systems.jpeg", text: "Environmental Management Systems" },
    { imgSrc: "/assets/img/certificates/Occupational-Health-Safety-Management-Systems.jpeg", text: "Occupational Health & Safety Management Systems" },
    { imgSrc: "/assets/img/certificates/duns-certificate.jpg", text: "D.U.N.S Certificate" },
    { imgSrc: "/assets/img/certificates/fssai-certificate.jpg", text: "FSSAI Certificate" },
    { imgSrc: "/assets/img/certificates/Income-Tax-certificate.jpeg", text: "Income Tax Certificate" },
    { imgSrc: "/assets/img/certificates/Cargo-Certificate.jpeg", text: "Cargo Certificate" }, 
    { imgSrc: "/assets/img/certificates/karnataka.jpeg", text: "Membership Certificate" },
    { imgSrc: "/assets/img/certificates/gst-certificate.jpg", text: "G.S.T Certificate" },
    { imgSrc: "/assets/img/certificates/ios.jpeg", text: "Management System Certificate" },
    { imgSrc: "/assets/img/certificates/onestar-certificate.jpg", text: "Import Export Code Certificate" },
    { imgSrc: "/assets/img/certificates/udyam-certificate.jpg", text: "Udyam Certificate" },
    { imgSrc: "/assets/img/certificates/apeda-certificate.jpg", text: "Apeda Certificate" },
    { imgSrc: "/assets/img/certificates/chemexill-certificate.jpg", text: "Chemexcil Certificate" },
    { imgSrc: "/assets/img/certificates/Pharmaceuticals-Certificate.jpg", text: "Pharmaceuticals Certificate" },

  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb
        title="Certificates"
        backgroundImage={"/assets/img/contact-banner.png"}
        height="40vh"
      />

      <section className="section-padding">
        <div className="container">
          <div className="certificates-grid">
            {certificatesData.map((cert, index) => (
              <div
                key={index}
                className="certificate-block"
                onClick={() => setActiveCert(cert)}
              >
                <img
                  src={cert.imgSrc}
                  alt={cert.text}
                  className="certificate-image"
                />
                <p className="certificate-title">
                  <strong>{cert.text}</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🔥 Popup */}
      {activeCert && (
        <div className="certificate-popup" onClick={() => setActiveCert(null)}>
          <div
            className="popup-inner"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="popup-close"
              onClick={() => setActiveCert(null)}
            >
              ✕
            </button>

            <img src={activeCert.imgSrc} alt={activeCert.text} />
            <p>{activeCert.text}</p>
          </div>
        </div>
      )}
    </>
  );
}
